
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { TranslateResult } from "vue-i18n";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";
import { BrowseService } from "@/services/browse-service";
import { Model, getModel } from "@/utils/models/model";
import { Browse } from "@/models/browse";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { DashboardRevenueNowCompareData } from "@/utils/dashboard/dashboard-revenue-now-compare-data";

export default Vue.extend({
	data(){
		return {
			data: new DashboardRevenueNowCompareData(),
			browse: undefined as undefined | Browse
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		model():Model | undefined{
			if (!this.browse) return undefined;
			return getModel(this.browse.Table);
		},
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardRevenueNowCompareData();
					return;
				}
				this.data = new DashboardRevenueNowCompareData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	async created() {
		this.browse = BrowseService.browses.find(b=>b.ID == 6);
	},
	components: {
		AppHumanFilterListEdit,
		AppSelectBookYear
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
